/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { BarcodeOutlined } from '@ant-design/icons';
import {
  Modal,
  Col,
  Row,
  Spin,
} from 'antd';
import {
  Title, Button, Text,
} from 'components';

import { printReferenceOrder } from 'api/recaudacion';
import Previewer from 'components/Previewer';
import _logger from 'utils/logger';

const ModalTransferencias = ({
  visible,
  onCancel,
  cbReferenciaBanco,
  isNewFolio,
}) => {
  const [visiblePreview, setVisiblePreview] = useState(false);
  const [previewBase64, setPreviewBase64] = useState();
  const [loading, setLoading] = useState(false);

  // Functions
  const showOrder = async () => {
    try {
      setLoading(true);
      if (isNewFolio) {
        const request = await cbReferenciaBanco();
        if (request) {
          const values = {
            folio: request.folio_banco,
            entidad: 1,
            referencia_normal: false,
            base64: request.data,
          };
          const order = await printReferenceOrder(values);
          if (order) {
            setPreviewBase64(values.base64 || order?.data);
            setVisiblePreview(true);
          }
        }
      } else {
        setVisiblePreview(true);
      }
    } catch (error) {
      _logger(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Modal
        visible={visible}
        footer={null}
        onCancel={() => onCancel()}
        width={700}
        closable={!loading}
        centered
        maskClosable={false}
        bodyStyle={{ padding: 0 }}
        cancelButtonProps={{
          style: {
            color: '#fff',
          },
        }}
      >
        <Spin
          spinning={loading}
          tip="Cargando..."
        >
          <div style={{ overflow: 'hidden', background: '#fff' }}>
            <div style={{ background: '#681B2D', padding: '24px 0', textAlign: 'center' }}>
              <Title level={4} $accent $bold color="#fff">
                Instrucciones para Transferencia Interbancaria
              </Title>
            </div>
            <Row gutter={0} style={{ margin: 0 }}>
              <Col xs={24} md={14} style={{ padding: '32px 24px 24px 24px', background: '#fff' }}>
                <Text>
                  Realiza tu transferencia interbancaria con los siguientes datos.
                </Text>
                <div
                  style={{
                    background: '#F7F7F7',
                    padding: 16,
                    borderRadius: 12,
                    marginTop: 16,
                    gap: 10,
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <div style={{ fontSize: 15 }}>
                    <b>Beneficiario:</b>
                    {' '}
                  </div>
                  <div style={{ fontSize: 15 }}>
                    <b>Banco destino:</b>
                    {' '}
                    BANORTE
                  </div>
                  <div style={{ fontSize: 15 }}>
                    <b>CLABE:</b>
                    {' '}
                  </div>
                </div>
                <ol style={{
                  paddingLeft: 18,
                  fontSize: 16,
                  color: '#333',
                  marginBottom: 18,
                }}
                >
                  <li style={{ marginBottom: 10 }}>
                    Genere su transferencia de pago correspondiente, la cual puedes generar
                    desde el botón de ubicado en la parte inferior con el texto
                    &quot;Generar orden de transferencia interbancaria&quot;
                  </li>
                  <li style={{ marginBottom: 10 }}>
                    Una vez generado el formato correspondiente, ingresa a tu banca en línea.
                  </li>
                  <li style={{ marginBottom: 10 }}>
                    Por primera vez, realice el alta del beneficiario, de lo contrario, agregue
                    la cuenta clabe interbancaria correspondiente y proceda al alta.
                  </li>
                  <li style={{ marginBottom: 10 }}>
                    El formato generado contiene una referencia de pago de a 20 digitos la cual
                    se debera colocar en el campo concepto de su banca electrónica al momento de
                    realizar la transferencia.
                  </li>
                </ol>
              </Col>
              <Col
                xs={24}
                md={10}
                style={{
                  background: '#F7F7F7',
                  padding: '32px 18px',
                  borderLeft: '1px solid #eee',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                }}
              >
                <div
                  style={{
                    color: '#681B2D',
                    fontWeight: 'bold',
                    fontSize: 17,
                    marginBottom: 12,
                    textAlign: 'center',
                  }}
                >
                  Información para alta del beneficiario
                </div>
                <div style={{ fontSize: 15, marginBottom: 8 }}>
                  <b>Nombre</b>
                  <br />
                </div>
                <div style={{ fontSize: 15, marginBottom: 8 }}>
                  <b>RFC</b>
                  <br />
                </div>
                <div style={{ fontSize: 15, marginBottom: 8 }}>
                  <b>Teléfono</b>
                  <br />
                </div>
                <div style={{ fontSize: 15 }}>
                  <b>Domicilio</b>
                  <br />
                </div>
              </Col>
            </Row>
            <div style={{
              padding: 24, background: '#fff', textAlign: 'center', borderTop: '1px solid #eee',
            }}
            >
              <Button
                $accent
                style={{ minWidth: 260, fontSize: 16, height: 44 }}
                onClick={async () => {
                  await showOrder();
                  onCancel();
                }}
                loading={loading}
                disabled={loading}
              >
                <BarcodeOutlined style={{ marginRight: 8, fontSize: 18 }} />
                <Text>
                  Generar orden de transferencia interbancaria
                </Text>
              </Button>
            </div>
          </div>
        </Spin>
      </Modal>
      <Previewer
        visible={visiblePreview}
        base64={previewBase64}
        isPDF
        onCancel={() => setVisiblePreview(false)}
      />
    </>
  );
};

export default ModalTransferencias;

ModalTransferencias.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func,
  cbReferenciaBanco: PropTypes.func.isRequired,
  isNewFolio: PropTypes.bool,
};

ModalTransferencias.defaultProps = {
  onCancel: null,
  isNewFolio: false,
};
